<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="modalProgramForm"
        :model="modalProgramForm"
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="modalProgramForm.categoryId"
                placeholder="请选择"
                @change="
                  getSelectOptions(
                    'phoneBrand',
                    'brandOptions',
                    modalProgramForm.categoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="modalProgramForm.brandId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2.5">
            <el-button type="primary" @click="getModalList">查询</el-button>
            <el-button type="primary" @click="addCtiy">创建</el-button>
          </el-col>
           <el-col :span="3.6">
              <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
              <el-upload
                      style="display:inline"
                      action="aa"
                      :show-file-list="false"
                      :before-upload="importSendInfo">
                <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
           </el-col>
          <el-col :span="2" style="margin-top:10px">
            <a type="primary" @click="getSkuTemplete">导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="name" label="机械硬盘"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="status" label="前端展示">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">展示</span>
            <span v-else>不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >展示</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不展示</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
              <el-button @click="deleteLinkage(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑机械硬盘' : '新建机械硬盘'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editModalForm"
            :model="editModalForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editModalForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="机械硬盘" prop="name">
              <el-input clearable v-model="editModalForm.name"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editModalForm.categoryId"
                placeholder="请选择"
                @change="
                  dlgChangeCategory(
                    'phoneBrand',
                    'dlgBrandOptions',
                    editModalForm.categoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="parentId">
              <el-select
                clearable
                v-model="editModalForm.parentId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in dlgBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      // 查询数据
      modalProgramForm: {
        categoryId: "",
        nameLike: "",
        brandId: "",
        typeKey: "sku_mechanical_drive",
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      typeKey: "sku_mechanical_drive",
      pageSize: 10,
      currentPage: 1,

      fullscreenLoading:false,

      // 新建编辑对话框数据

      isDlg: false,
      editModalForm: {
        id: null,
        value: null,
        name: null,
        categoryId: "",
        typeKey: "sku_mechanical_drive",
        parentId: null,
        face: false,
        ycy: false,
        fingerprint: false,
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入沟通渠道", trigger: "change" },
        ],
        parentId: [
          { required: true, message: "请选择品牌", trigger: "change" },
        ],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteLinkage(id){
      let self = this
        self.$confirm('是否删除').then(() => {
            self.$api.deleteLinkage({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getModalList()
          }
      })
      })
  
    },
    // click事件
    exportExcelData () {
      let self = this
      self.$api
        .getClass({
          typeKey: self.typeKey,
          page: 1,
          size: self.tableTotal,
          categoryId: self.modalProgramForm.categoryId || null,
          brandId: self.modalProgramForm.brandId || null,
          nameLike: self.modalProgramForm.nameLike || null,
        })
        .then((res) => {
          var downLoadTableData = res.data.records || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName = ["编号", "分类","品牌","机械硬盘","创建时间"];
                const filterVal = ["value", "categoryName", "brandName", "name", "createTime"];
                const data = downLoadTableData.map(v => filterVal.map(j => v[j]));
                export_json_to_excel(fieldName, data, "机械硬盘"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
     // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      formData.append('type',10)
      this.$api.imporSkuTemplete(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getModalList()
        }
      })
      return false;
    },
    getSkuTemplete(){
      window.open(`/api/hjx/sku/getSkuTemplete?type=10`,"_blank")
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getModalList();
    },

    // 获取表格数据
    getModalList() {
      let self = this;
      self.$api
        .getClass({
          typeKey: self.typeKey,
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.modalProgramForm.categoryId || null,
          brandId: self.modalProgramForm.brandId || null,
          nameLike: self.modalProgramForm.nameLike || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addCtiy() {
      this.dlgType = "new";
      this.editModalForm=this.$options.data().editModalForm;
      this.$nextTick(()=>{
          this.$refs['editModalForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.editModalForm = {
        id: null,
        value: null,
        name: null,
        categoryId: "",
        typeKey: "sku_mechanical_drive",
        parentId: null,
        face: false,
        ycy: false,
        fingerprint: false,
      };

      self.dlgType = "change";

      for (let i in self.editModalForm) {
        if (i === "parentId") {
          self.editModalForm[i] = row.brandId;
        } else {
          if (row[i]) self.editModalForm[i] = row[i];
        }
      }
      self.getSelectOptions(
        "phoneBrand",
        "dlgBrandOptions",
        self.editModalForm.categoryId
      );
      self.isDlg = true;
    },

    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
      this.editModalForm.parentId = null;
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editModalForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editModalForm) {
            params[i] = this.editModalForm[i];
          }
          if (self.dlgType === "change") {
            self.$api.changeLinkage(params.id, params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                self.getModalList();
                self.closeEditormodelDlg();
              }
            });
          } else {
            self.$api.addLinkage(params).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                self.getModalList();
                self.closeEditormodelDlg();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      self.$api
        .changeLinkage(row.id, {
          name: row.name,
          status: newStatus,
          typeKey: "sku_mechanical_drive",
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            self.getModalList();
          }
        });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api
        .changeLinkageOrder({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getModalList();
          }
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getModalList();
    self.getSelectOptions("category", "categoryOptions");
  },
};
</script>
<style lang="less" scoped></style>
